import { render, staticRenderFns } from "./setPwdByMobile.vue?vue&type=template&id=fd7c9898"
import script from "./setPwdByMobile.vue?vue&type=script&lang=js"
export * from "./setPwdByMobile.vue?vue&type=script&lang=js"
import style0 from "./setPwdByMobile.vue?vue&type=style&index=0&id=fd7c9898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports